import {  Stack, Typography, Grid, Box } from "@mui/material"
import { withTheme } from "@emotion/react"
import { Divider } from "@mui/material"
import FooterLinks from "./FooterLinks"
import FooterLogo from "./FooterLogo"


const links = ['Physician', 'Dentist', 'Nuclear', 'Xray', 'Therapist']
const times = [{ day: 'Monday - Friday', time: "8:00 - 18:00" }, { day: 'Monday - Friday', time: "8:00 - 18:00" }, { day: 'Sunday', time: "8:00 - 18:00" }]

const Departments = (props) => {

    return (
        <Box gap="24px" alignItems="baseline" flexDirection="column" display="flex" sx={{ width: 'auto' }}>
            <Typography sx={{ ...props.theme.typography.heading, color: props.theme.palette.secondary.black }}>Our Departments</Typography>
            <Grid direction='row' container rowSpacing="16px" >
                {
                    links.map((link, index) => (
                        <Grid item key={index} xs={6}>
                            <Typography sx={{ ...props.theme.typography.body, color: props.theme.palette.secondary.black }}>{link}</Typography>
                        </Grid>
                    ))
                }
            </Grid>
        </Box>
    )

}

const WorkDays = (props) => {

    return (
        <Box flexWrap={{ sm:"wrap-reverse"}} gap="24px" alignItems="baseline" flexDirection="column" display='flex' sx={{ width: 'auto' }}>
            <Typography sx={{ ...props.theme.typography.heading, color: props.theme.palette.secondary.black }} >We are available</Typography>
            <Grid direction='row' container rowSpacing="16px" columnSpacing={{ xs: "49px" }}>
                <Box gap={{xs:'20px'}} display="flex" flexDirection="column">
                    {
                        times.map((item,i) => (
                            <Stack key={i} spacing={{xs:"8px", sm:'50px'}} direction={{xs:'row',sm:'row'}} >
                                <Typography width={107} sx={{ ...props.theme.typography.body, color: props.theme.palette.secondary.black }} >{item.day}</Typography>
                                <Typography sx={{ ...props.theme.typography.body, color: props.theme.palette.secondary.black }}>{item.time}</Typography>
                            </Stack>
                        ))
                    }
                </Box>

            </Grid>
        </Box>
    )

}


const Footer = (props) => {
    return (

        <Box mx='16px'  justifyContent="space-between" display= "flex"   width="100%" flexDirection= "column">
            <Box justifyContent="space-between" alignItems="flex-start" display="flex" width="100%" flexDirection={{xs:'column',sm:'row'}} >

                <Box justifyContent="space-between"  width={{xs:'inherit',sm:'unset'}} gap="24px" display="flex" flexDirection='column' alignItems={{ xs:'flex-start' ,sm:"start"}}>
                    <FooterLogo/>
                    <Typography width={{ xs:"186px", sm:'259px'}} color='#292727' fontSize='14px' fontFamily='Inter' fontWeight={300}>
                        The best place for home health care for a healthy community
                    </Typography>
                    <FooterLinks/>
                </Box>

                <Box gap={{xs:'48px',sm:'96px'}}  mt={{xs:'50px',sm:'0px'}}  alignItems="baseline" display="flex" flexDirection={{xs:'column',sm:'row'}} >
                    <Departments theme={props.theme} />
                    <WorkDays theme={props.theme} />
                </Box>

            </Box>
            <Divider sx={{ marginTop: '48px', marginBottom: '24px' }} />
            <Stack  alignItems="baseline" gap={{xs:'8px'}} justifyContent={{ xs:'space-evenly', sm:"space-between"}} direction={{xs:'row',md:'row'}} >
                <Typography sx={{ ...props.theme.typography.body, color: props.theme.palette.secondary.black }} >Copyright ©2023 Care in Touch</Typography>
                <Typography mb="48px" sx={{ ...props.theme.typography.body, color: props.theme.palette.secondary.black }}>Designed by Filly Coder</Typography>
            </Stack>

        </Box>

    )
}

export default withTheme(Footer);